import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetcher } from 'src/api/fetcher';
import { api } from 'src/utils/api';
import { API_RESOURCES } from 'src/utils/constants';
import { getUuid } from 'src/utils/url';

export const useStockActionForRun = (runUri, stockUri, key = 'stock-action-for-run') => {
  return useQuery({
    queryKey: ['stock-action-by-run-and-stock', key, runUri, stockUri],
    queryFn: () =>
      fetcher(API_RESOURCES.MATERIAL_STOCK_ACTION, {
        params: {
          'filter[run]': runUri,
          'filter[source_stock]': stockUri,
        },
      }),
    enabled: !!runUri && !!stockUri,
    select: data => {
      const resources = data.resources;
      return resources;
    },
  });
};

export const useCreateStockAction = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async payload => {
      return await api
        .post(`${API_RESOURCES.MATERIAL_STOCK_ACTION}/`, {
          json: payload,
        })
        .json();
    },
    onSuccess: () => {
      // Invalidate all stock-action related queries to refresh badges
      queryClient.invalidateQueries(['stock-action-by-run-and-stock']);
      queryClient.invalidateQueries(['stock-actions']);
      queryClient.invalidateQueries(['stock-action-relationships']);
    },
  });
};

export const useUpdateStockAction = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ stockActionUri, payload }) => {
      const uuid = getUuid(stockActionUri);
      return await api
        .put(`${API_RESOURCES.MATERIAL_STOCK_ACTION}/${uuid}/`, {
          json: payload,
        })
        .json();
    },
    onSuccess: () => {
      // Invalidate all stock-action related queries to refresh badges
      queryClient.invalidateQueries(['stock-action-by-run-and-stock']);
      queryClient.invalidateQueries(['stock-actions']);
      queryClient.invalidateQueries(['stock-action-relationships']);
    },
  });
};
